import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  StyledButton,
  StyledIcon,
  StyledStreamVerb,
  TransparentElement
} from './QuickStreamButton.styled';

import { ToolTip } from '@shoflo/polymer';

import QuickStreamButtonPopOver from './QuickStreamButtonPopOver';

/**
 * Simple QuickStreamButton component designed to play or stop streams
 *
 * @param {*} param
 * @returns
 */
function QuickStreamButton({
  icon,
  color,
  text,
  tooltipText,
  onClick,
  confirmOnClick,
  confirmOnClickQuery,
  disabled,
  opacity
}) {
  const showTooltip = tooltipText !== '';
  const [confirmClick, setConfirmClick] = useState(false);

  function callBackHandler() {
    confirmOnClick ? setConfirmClick(!confirmClick) : onClick();
  }

  function noThanksCallback() {
    setConfirmClick(false);
  }

  function stopStreamingCallback() {
    onClick();
    setConfirmClick(false);
  }

  return (
    <>
      <TransparentElement
        show-popover={showTooltip.toString()}
        id="stream-tooltip"
        data-testid="stream-tooltip-transparent"
      />
      <StyledButton
        onClick={callBackHandler}
        data-testid="quick-stream-button"
        title={text}
        color={color}
        disabled={disabled}
        opacity={opacity}
        confirmClick={confirmClick}
      >
        <StyledIcon
          icon={icon}
          className={icon.iconName === 'spinner' ? 'fa-spin' : ''}
        />
        <StyledStreamVerb> {text} </StyledStreamVerb>
      </StyledButton>
      <ToolTip
        placement="bottom"
        targetElement="stream-tooltip"
        message={tooltipText}
      />
      <QuickStreamButtonPopOver
        show={confirmClick}
        confirm={stopStreamingCallback}
        cancel={noThanksCallback}
        query={confirmOnClickQuery}
        text={text.replace(/Streaming/gi, '')}
      />
    </>
  );
}

QuickStreamButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.object,
  text: PropTypes.string.isRequired,
  tooltipText: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  confirmOnClick: PropTypes.bool,
  confirmOnClickQuery: PropTypes.string,
  showPopOver: PropTypes.bool,
  opacity: PropTypes.number
};

export default QuickStreamButton;
